import React, { FC } from 'react';

import { UserProfile } from 'api';
import { EmptyState, IEmptyState } from 'components';

import VirtualizedTable from 'features/admin/VirtualizedTable';

interface IProps {
  className: string;
  columns: object[];
  profiles: UserProfile[];
  onLoadMore: () => void;
  count: number;
  emptyStateName: keyof IEmptyState;
}

const Table: FC<IProps> = props => {
  const { className, columns, emptyStateName, profiles, onLoadMore, count } = props;

  return (
    <VirtualizedTable
      columns={columns}
      outerBorderWidth={2}
      spacing={1}
      headerHeight={50}
      rowHeight={75}
      total={count}
      rowCount={profiles.length}
      headerClassName={className}
      isRowLoaded={({ index }: { index: number }) => !!profiles[index]}
      rowGetter={({ index }: { index: number }) => profiles[index]}
      onLoadMoreRows={onLoadMore}
      noRowsRenderer={() => <EmptyState name={emptyStateName} />}
    />
  );
};

export default Table;
